import { render, staticRenderFns } from "./calendarEventUpdate.vue?vue&type=template&id=180ea3c6&"
import script from "./calendarEventUpdate.vue?vue&type=script&lang=js&"
export * from "./calendarEventUpdate.vue?vue&type=script&lang=js&"
import style0 from "./calendarEventUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports